export type AlertType = 'early' | 'late' | 'none';

export function predictedTimeIsLate(estimatedUnixTime: number, predictedUnixTime: number): boolean {
    return predictedUnixTime > estimatedUnixTime;
}

export function predictedTimeIsEarly(estimatedUnixTime: number, predictedUnixTime: number): boolean {
    return predictedUnixTime < estimatedUnixTime;
}

export function differenceMeetsAlertThreshold(
    estimatedUnixTime: number,
    predictedUnixTime: number,
    alertThreshold: number
): boolean {
    return Math.abs(estimatedUnixTime - predictedUnixTime) >= alertThreshold;
}

export function getPredictedTimeAlert(
    estimatedUnixTime: number | undefined,
    predictedUnixTime: number | undefined,
    alertThresholdEarly: number,
    alertThresholdLate: number
): AlertType {
    if (estimatedUnixTime !== undefined && predictedUnixTime !== undefined) {
        if (
            predictedTimeIsEarly(estimatedUnixTime, predictedUnixTime) &&
            differenceMeetsAlertThreshold(estimatedUnixTime, predictedUnixTime, alertThresholdEarly)
        ) {
            return 'early';
        }
        if (
            predictedTimeIsLate(estimatedUnixTime, predictedUnixTime) &&
            differenceMeetsAlertThreshold(estimatedUnixTime, predictedUnixTime, alertThresholdLate)
        ) {
            return 'late';
        }
    }

    return 'none';
}

export function getAlertClassByArrivalEventType(
    arrivalEventType: 'in' | 'on',
    estimatedTime: number | undefined,
    predictedTime: number | undefined,
    thresholdEarly: number,
    thresholdLate: number
): string {
    // If neither estimated nor predicted time is set,
    // no styles need to be applied, so just return an empty string.
    if (estimatedTime === undefined || predictedTime === undefined) {
        return '';
    }

    if (predictedTimeIsEarly(estimatedTime, predictedTime)) {
        if (differenceMeetsAlertThreshold(estimatedTime, predictedTime, thresholdEarly)) {
            return `flight--predicted-${arrivalEventType}-early-alert`;
        }
        return `flight--predicted-${arrivalEventType}-early`;
    } else if (predictedTimeIsLate(estimatedTime, predictedTime)) {
        if (differenceMeetsAlertThreshold(estimatedTime, predictedTime, thresholdLate)) {
            return `flight--predicted-${arrivalEventType}-late-alert`;
        }
        return `flight--predicted-${arrivalEventType}-late`;
    }

    return '';
}

export function getAlertClasses(
    estimatedOn: number | undefined,
    predictedOn: number | undefined,
    estimatedIn: number | undefined,
    predictedIn: number | undefined,
    thresholdEarly: number,
    thresholdLate: number
): string {
    const alertClasses: string[] = [];

    alertClasses.push(getAlertClassByArrivalEventType('in', estimatedIn, predictedIn, thresholdEarly, thresholdLate));
    alertClasses.push(getAlertClassByArrivalEventType('on', estimatedOn, predictedOn, thresholdEarly, thresholdLate));

    return alertClasses.filter((alertClass) => alertClass != '').join(' ');
}
